import type { Op } from 'quill/core';
import React, { useState } from 'react';
import EditingOrganizationSummary from './EditingOrganizationSummary';
import * as styles from './OrganizationSummary.module.scss';
import ReadonlyOrganizationSummary from './ReadonlyOrganizationSummary';
import { deltaOnlyContainWhitespace } from '../../utils/deltaHelpers';

const DEFAULT_VALUES = [{ insert: '\n\n' }];

interface OrganizationSummaryProps {
  summary: Op[] | null;
}

const OrganizationSummary = ({ summary }: OrganizationSummaryProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const isSummaryEmpty = !summary || deltaOnlyContainWhitespace(summary);

  return (
    <header className={styles.container} aria-label="Organization Summary">
      {isEditing ? (
        <EditingOrganizationSummary
          summary={
            isSummaryEmpty
              ? DEFAULT_VALUES // Show at least two lines so user can see the placeholder
              : summary
          }
          onCancelEditing={() => setIsEditing(false)}
        />
      ) : (
        <ReadonlyOrganizationSummary
          summary={isSummaryEmpty ? null : summary}
          onStartEditing={() => setIsEditing(true)}
        />
      )}
    </header>
  );
};

export default OrganizationSummary;
